/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_YesInputs */

const en_hub_yes = /** @type {(inputs: Hub_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supported`)
};

const id_hub_yes = /** @type {(inputs: Hub_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Didukung`)
};

/**
* | output |
* | --- |
* | "Supported" |
*
* @param {Hub_YesInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_yes = /** @type {((inputs?: Hub_YesInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_YesInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_yes(inputs)
	return en_hub_yes(inputs)
});